import {
  REACT_APP_CHECKOUT_VERSION,
  REACT_APP_SCRIPT_CHECKOUT,
  REACT_APP_SCRIPT_CHECKOUT_PAGO,
  REACT_APP_SCRIPT_CHECKOUT_PAGO_V2,
  REACT_APP_SCRIPT_CHECKOUT_PAGO_SRI,
  REACT_APP_SCRIPT_CHECKOUT_PAGO_V2_SRI,
  REACT_APP_SCRIPT_CHECKOUT_SRI,
} from '../config/env';

export const checkoutVersion = REACT_APP_CHECKOUT_VERSION;
export const CHECKOUT_VERSION = {
  V1: "1",
  V2: "2",
}

export const checkoutScriptVersion = REACT_APP_SCRIPT_CHECKOUT;

export const checkoutPagoScriptVersion = checkoutVersion === CHECKOUT_VERSION.V1
  ? REACT_APP_SCRIPT_CHECKOUT_PAGO
  : REACT_APP_SCRIPT_CHECKOUT_PAGO_V2;

export const checkoutPagoScriptIntegrity =
  checkoutVersion === CHECKOUT_VERSION.V1
    ? REACT_APP_SCRIPT_CHECKOUT_PAGO_SRI
    : REACT_APP_SCRIPT_CHECKOUT_PAGO_V2_SRI

export const checkoutScriptIntegrity = REACT_APP_SCRIPT_CHECKOUT_SRI

export const checkoutType = {
    ONPAGE: 'onpage',
    STANDARD: 'standard',
}